<template>
  <div 
    :id="$attrs._id"
    class="tag-basic-icon"
    :dir="language.rtl ? 'rtl' : 'ltr'"
    :style="styles"
  >
    <fa class="tag-basic-icon__icon" :icon="['fad', faIcon]"/>
    <div class="tag-basic-icon__label" v-html="label[language.code]"></div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'label', 'icon'],
 
  computed: {
    faIcon () {
      return this.icon || 'car'
    },

    language () {
      return this.$store.getters.language
    },

    styles () {
      return {
        // divide by font size
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.tag-basic-icon {
  background-color: $basic-icon-tag-bg-color;
  border-radius: 50%;
  box-shadow: $tag-box-shadow;
  color: $white;
  display: flex;
  font-size: 1em;
  height: 2.5em;
  letter-spacing: .05em;
  line-height: 1.2em;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  width: 2.5em;
  z-index: 5;

  opacity: 0;
  transform: translateY(1rem);

  &.enter {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.2s, transform 0.6s;
  }  

  &::before{
    background: $basic-icon-tag-bg-color;
    bottom: 100%;
    box-shadow: $tag-box-shadow;
    content: '';
    height: 2.5rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: .25em;
  }

  &__label {
    background-color: $basic-icon-tag-bg-color;
    border-radius: $basic-icon-tag-border-radius;
    box-shadow: $tag-box-shadow;
    color: $basic-icon-tag-font-color;
    font-size: $basic-icon-tag-font-size;
    font-weight: 300;
    left: 50%;
    letter-spacing: .1em;
    line-height: 1.2em;
    width: max-content;
    padding: 0.4em 1.2em 0.2em;
    pointer-events: auto;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    transform: translate(-50%, -5em);
    user-select: none;
  }

  &__icon {
    font-size: 1.5em;
    margin: auto;
  }
}
</style>
